import React from "react";
import "./Satodime.css"; // Import the CSS file

function Satodime() {
  return (
    <div className="satodime-container">
      <h1>Satodime Instructions</h1>
      <p>
        Learn how to set up and use the Satodime solution for secure
        cryptocurrency gifting and transfers. Follow the detailed steps below to
        build your own Satodime card or use the prebuilt applications for easy
        operation.
      </p>

      <h2>Creating the Satodime Card</h2>
      <ol>
        <li>
          Clone the{" "}
          <a
            href="https://github.com/Toporin/Satodime-Applet"
            target="_blank"
            rel="noopener noreferrer"
            className="satodime-link"
          >
            Satodime Applet repository
          </a>{" "}
          repository:
          <div className="code-block">
            <code>git clone git@github.com:Toporin/Satodime-Applet.git</code>
          </div>
        </li>
        <li>
          Build the Satodime applet:
          <ul>
            <li>
              Option 1: Download an existing release from the{" "}
              <a
                href="https://github.com/Toporin/Satodime-Applet/releases"
                target="_blank"
                rel="noopener noreferrer"
                className="satodime-link"
              >
                Satodime Applet Releases
              </a>
              . (Recommended)
            </li>
            <li>
              Option 2: Follow the steps in the README to create your own build.
              <ul>
                <li>
                  Download the latest release of{" "}
                  <a
                    href="https://github.com/martinpaljak/ant-javacard/releases/latest/download/ant-javacard.jar"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="satodime-link"
                  >
                    Ant-Javacard
                  </a>{" "}
                  and place it in the `lib` folder.
                </li>
                <li>
                  Install Apache Ant:
                  <div className="code-block">
                    <code>sudo apt install ant</code>
                  </div>
                </li>
                <li>
                  Use or install the recommended Java JDK (8 or 11):
                  <div className="code-block">
                    <code>sudo update-alternatives --config java</code>
                  </div>
                </li>
                <li>
                  Download the Javacard SDK into the `satodime` project in the
                  `sdks` folder:
                  <div className="code-block">
                    <code>
                      git submodule add
                      https://github.com/martinpaljak/oracle_javacard_sdks sdks
                    </code>
                  </div>
                </li>
                <li>
                  Build the project using Apache Ant:
                  <div className="code-block">
                    <code>ant</code>
                  </div>
                  This will generate the `.cap` file in the `Satodime-Applet`
                  folder.
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          Put the <code>.cap</code> file in the same folder as the{" "}
          <code>gp.jar</code> file, which is located in the{" "}
          <code>tool/target</code> directory of the GlobalPlatformPro
          repository.
          <div className="code-block">
            <code>
              mv &lt;path-to-Applet&gt;/Satodime-Applet/Satodime-3.0.4.cap
              &lt;path-to-GP&gt;/GlobalPlatformPro/tool/target/
            </code>
          </div>
        </li>
        <li>
          Connect an NFC reader to your computer and insert your Java J3R180 NFC
          card.
        </li>
      </ol>

      <h2>Loading the Satodime Applet on the Card</h2>
      <ul>
        <li>
          <strong>Windows:</strong>
          <ul>
            <li>
              List the applets on the card:
              <div className="code-block">
                <code>gp.exe -l</code>
              </div>
            </li>
            <li>
              Load the applet:
              <div className="code-block">
                <code>gp.exe -install .\Satodime-3.0.4.cap</code>
              </div>
            </li>
            <li>
              Delete the applet:
              <div className="code-block">
                <code>gp.exe -uninstall .\Satodime-3.0.4.cap</code>
              </div>
            </li>
          </ul>
        </li>
        <li>
          <strong>Ubuntu/Linux:</strong>
          <ul>
            <li>
              List the applets on the card:
              <div className="code-block">
                <code>java -jar gp.jar -l</code>
              </div>
            </li>
            <li>
              Load the applet:
              <div className="code-block">
                <code>java -jar gp.jar -install ./Satodime-3.0.4.cap</code>
              </div>
            </li>
            <li>
              Delete the applet:
              <div className="code-block">
                <code>java -jar gp.jar -uninstall ./Satodime-3.0.4.cap</code>
              </div>
            </li>
          </ul>
        </li>
      </ul>

      <h2>Using Satodime</h2>
      <ul>
        <li>
          Download and install the Satodime applications:
          <ul>
            <li>
              Android:{" "}
              <a
                href="https://github.com/Toporin/Satodime-Android"
                target="_blank"
                rel="noopener noreferrer"
                className="satodime-link"
              >
                Satodime Android App
              </a>
            </li>
            <li>
              iOS:{" "}
              <a
                href="https://github.com/Toporin/Satodime-iOS"
                target="_blank"
                rel="noopener noreferrer"
                className="satodime-link"
              >
                Satodime iOS App
              </a>
            </li>
          </ul>
        </li>
        <li>
          Use the Satodime app to securely manage transactions and gifting.
          Refer to the video tutorials linked in the instructions above.
        </li>
      </ul>
    </div>
  );
}

export default Satodime;
